import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./loginNew.module.scss";
import { useNavigate } from "react-router-dom";
import { PermIdentity, Visibility, VisibilityOff } from "@mui/icons-material";
// import { authUser, authUserResponse, loginUsers } from "../../store/actions";
import { storeObjectData } from "../../utils/common/cookies";
import toast from "react-hot-toast";
import { UseEncrypt, UseDecrypt } from "../../customHooks/CryptoHooks";
import loginPageBg from "../../assets/images/Embg.png";
import { authUser, loginUser } from "../../store/actions";
import { ssoConfig } from "../../utils/sso/config";
import { createPkce, createState } from "../../utils/sso/pkce";
import companyLogo from "../../assets/logo/cmpLogo.png";
// import { FadeLoader } from "react-spinners";

const InitialState = {
  // DEFAULT
  userName: "",
  password: "",
  showPassword: false,
};
const initialMsg = {
  email: "",
  pwd: "",
};
const LoginNew = ({ user }) => {
  const [values, setValues] = useState(InitialState);
  const [errorMsg, setErrorMsg] = useState(initialMsg);
  const [checked, setChecked] = useState(false);
  //   const [loading, setLoading] = useState(false); // check
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.id) {
      handleLoginSuccess(user);
    }
  }, [user]);

  const isValidMobileOrEmail = (input) => {
    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return mobileRegex.test(input) || emailRegex.test(input);
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFieldChange = (fieldName, value) => {
    setErrorMsg(initialMsg);

    if (fieldName === "userName") {
      // remove any whitespace so previous valid input stays visible
      const sanitizedValue = value.replace(/\s+/g, "");
      value = sanitizedValue;

      if (/^\d+$/.test(value)) {
        value = value.slice(0, 10);
      }

      if (value && !isValidMobileOrEmail(value)) {
        setErrorMsg((prev) => ({
          ...prev,
          email: "Enter valid mobile number or email",
        }));
      }
    }

    setValues({
      ...values,
      [fieldName]: value,
    });
  };

  const isLoginDisabled =
    !values.userName ||
    !values.password ||
    values.userName.length < 3 ||
    values.password.length < 3 ||
    !!errorMsg.email;

  const handleLoginSuccess = (data = {}) => {
    if (!checked) {
      storeObjectData("rmd", null);
    }
    // setLoading(false);
    switch (user?.role) {
      case "admin":
        return navigate("/");
      case "dispatcher":
        return navigate("/cartBundleOrdersDispatcher");
      case "packager":
        return navigate("/cartBundleOrdersPackager");
      default:
        return navigate("/");
    }
  };

  const login = () => {
    dispatch(
      loginUser({
        username: values.userName,
        password: values.password,
        callback: {
          success: (data) => handleLoginSuccess(data),
        },
      })
    );
  };

  const handleSsoLogin = async () => {
    const { verifier, challenge } = await createPkce();
    const state = createState();
    sessionStorage.setItem("sso_verifier", verifier);
    sessionStorage.setItem("sso_state", state);
    const query = new URLSearchParams({
      response_type: "code",
      client_id: ssoConfig.clientId,
      redirect_uri: ssoConfig.redirectUri,
      scope: ssoConfig.scope,
      code_challenge: challenge,
      code_challenge_method: "S256",
      state,
    });
    window.location.href = `${ssoConfig.authorizeUrl}?${query}`;
  };

  const handleRmd = () => {
    const rmdDate = new Date();
    rmdDate.setDate(rmdDate.getDate() + 365);
    const encryptedRmdDate = UseEncrypt(rmdDate.toISOString());
    const encryptedPassword = UseEncrypt(values.password);

    storeObjectData("rmd", {
      rmd: encryptedRmdDate,
      password: encryptedPassword,
      userName: values.userName,
    });

    login();
  };

  const handleSubmit = () => {
    // localStorage.clear();
    // setLoading(true);
    if (isLoginDisabled) {
      // setLoading(false);
      return;
    }

    if (!isValidMobileOrEmail(values.userName)) {
      setErrorMsg((prev) => ({
        ...prev,
        email: "Enter valid mobile number or email",
      }));
      return;
    }

    dispatch(
      authUser({
        payload: {
          username: values.userName,
          password: values.password,
        },
        callback: {
          success: () => (checked ? handleRmd() : login()),
          failure: () => {
            // setLoading(false);
            toast.error("Invalid username or password");
          },
        },
      })
    );
  };

  const handleKeyDown = (event, key) => {
    if (event.key === "Enter" && key === "password" && !isLoginDisabled) {
      handleSubmit();
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSubmit();
  };

  return (
    <div
      className={styles.container}
      style={{ "--login-page-background-image": `url(${loginPageBg})` }}
    >
      {/* {loading ? (
        <div className={styles.loadingContainer}>
          <FadeLoader
            color={"#014751"}
            loading={loading}
            size={120}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : null} */}
      <div className={styles.glassCard}>
        <div className={styles.header}>
          <img src={companyLogo} alt="" className={styles.companyLogo} />
          {/* <h1 className={styles.heading}>CollabOn&#174; Campus</h1> */}
          <p className={styles.subheading}>
            Welcome back please login to your account
          </p>
        </div>
        <div className={styles.form}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={handleSsoLogin}
          >
            Sign in with Kriha
          </button>
        </div>
        {/* <p className={styles.signupPrompt}>
          Don&apos;t have an account? <span>Signup</span>
        </p> */}
        <a
          href="https://krihaitsolutions.com"
          target="_blank"
          rel="noreferrer"
          className={styles.createdBy}
        >
          Designed by <span>Kriha&#174;</span>
        </a>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    user: state.login.user,
  };
};

export default connect(mapStateToProps, null)(LoginNew);
